import { Stack } from '@chakra-ui/react';
import Link from 'next/link';
import React from 'react';
import EntityTable from './EntityTable';
import { H4 } from '@/components/Headings';
import { colors } from '@/styles/theme/colors';
import { TextDefault } from '@/components/Texts';

const Data = () => {
  return (
    <Stack w='full' align={'center'} pt={{ base: 8, md: 20 }} pb={4} px={4}>
      <Stack
        w='full'
        maxW={'8xl'}
        textAlign={'start'}
        color={colors.diment.darkBlue}
        fontWeight={500}
      >
        <H4 fontWeight={700}>
          <H4 fontWeight={500} as={'span'} color={colors.diment.lightBlue}>
            1.
          </H4>{' '}
          Imprint details
        </H4>
        {/* <TextDefault>Responsible service provider:</TextDefault> */}
        <TextDefault fontWeight={800}>Diment</TextDefault>
        {/* <TextDefault maxW={430}>
          First Floor Almas Tower, Jumeirah Lakes Towers, PO Box 371653 Dubai,
          United Arab Emirates
        </TextDefault> */}
        {/* <TextDefault>
          Managing Director and Chairman of the Board of Directors:{' '}
          <TextDefault as='span' fontWeight={800}>
            Mr. Max Weiland
          </TextDefault>
        </TextDefault> */}
        <Link href={'mailto:support@Diment.io'}>
          <TextDefault>
            E-Mail:{' '}
            <TextDefault
              as='span'
              fontWeight={700}
              color={colors.diment.lightBlue}
            >
              support@diment.io{' '}
            </TextDefault>
          </TextDefault>
        </Link>
        <Link href={'/'}>
          <TextDefault>
            URL:{' '}
            <TextDefault
              as='span'
              fontWeight={700}
              color={colors.diment.lightBlue}
            >
              https://www.diment.io
            </TextDefault>
          </TextDefault>
        </Link>
        {/* <EntityTable /> */}
        <H4 mt={8} fontWeight={700}>
          <H4 fontWeight={500} as={'span'} color={colors.diment.lightBlue}>
            2.
          </H4>{' '}
          Disclaimer
        </H4>
        <TextDefault>
          The contents of these pages were created with the utmost care.
          Nevertheless, we assume no liability for the accuracy, completeness
          and timeliness of the content.{' '}
        </TextDefault>
        <TextDefault>
          The website contains links to other sites on the Internet, whose
          content and updating are beyond our control and which we cannot check
          for legality and completeness. The respective provider or operator is
          responsible for the content of the linked pages. Accordingly, any
          liability in this regard is excluded in its entirety.
        </TextDefault>
        <H4 mt={8} fontWeight={700}>
          <H4 fontWeight={500} as={'span'} color={colors.diment.lightBlue}>
            3.
          </H4>{' '}
          Online Dispute Resolution
        </H4>
        <TextDefault>
          The EU Commission has set up an Internet platform for online dispute
          resolution. The platform serves as a contact point for the
          out-of-court settlement of disputes about contractual obligations
          arising from online service or purchase contracts. More information
          can be found at the following link:{' '}
          <a
            href='http://ec.europa.eu/consumers/odr'
            style={{ color: '#206bbb', cursor: 'pointer' }}
          >
            http://ec.europa.eu/consumers/odr
          </a>
          . We are neither willing nor obliged to participate in dispute
          resolution proceedings before a consumer arbitration board.
        </TextDefault>
        <H4 mt={8} fontWeight={700}>
          <H4 fontWeight={500} as={'span'} color={colors.diment.lightBlue}>
            4.
          </H4>{' '}
          Data Protection
        </H4>
        <TextDefault>
          You can find our data protection information{' '}
          <Link
            href={'/legal-terms'}
            style={{ color: '#206bbb', cursor: 'pointer' }}
          >
            here
          </Link>
        </TextDefault>
        <H4 mt={8} fontWeight={700}>
          <H4 fontWeight={500} as={'span'} color={colors.diment.lightBlue}>
            5.
          </H4>{' '}
          Copyright Notice
        </H4>
        <TextDefault>
          The texts, images, photos, videos or graphics available on our website
          are generally subject to copyright protection. Any unauthorized use
          (especially copying, editing or distribution) of these copyrighted
          contents is therefore prohibited. If you intend to use this content or
          parts thereof, please contact us in advance using the details above.
          If we are not the owner of the required copyrights, we will make every
          effort to establish contact with the copyright holder.
        </TextDefault>
        <H4 mt={8} fontWeight={700}>
          <H4 fontWeight={500} as={'span'} color={colors.diment.lightBlue}>
            6.
          </H4>{' '}
          Layout and implementation of the website
        </H4>
        <TextDefault fontWeight={800}>Diment</TextDefault>
        {/* <TextDefault>
          First Floor Almas Tower, Jumeirah Lakes Towers, PO Box 371653 Dubai,
          United Arab Emirates
        </TextDefault> */}
        <TextDefault mt={4} fontWeight={800} align={'end'}>
          7.12.2023
        </TextDefault>
      </Stack>
    </Stack>
  );
};

export default Data;
